import React from 'react';
import PropTypes from 'prop-types';
import SVGWrap from './SVGWrap';

const Map = ({ outlineColor, s }) => (
  <SVGWrap style={s}>
    <path
      fill={outlineColor}
      d="M315.9,155.4c0-35.3-28.7-64-64-64s-64,28.7-64,64c0,35.3,28.7,64,64,64S315.9,190.7,315.9,155.4z M206,155.4
	c0-25.3,20.6-45.9,45.9-45.9s45.9,20.6,45.9,45.9s-20.6,45.9-45.9,45.9S206,180.7,206,155.4z"
    />
    <path
      fill={outlineColor}
      d="M506.6,475.1l-20.3-70.7l-22.8-79.1c-3.8-13.2-17.5-23.4-31.3-23.4h-84.3c31.2-47.5,61.6-105.1,61.6-149.8
	c0-83.8-68.7-152-153-152s-153,68.2-153,152c0,44.8,30.4,102.4,61.6,149.8H80.8c-13.8,0-27.5,10.3-31.3,23.4l-22.8,79.2L6.4,475.1
	c-2.7,9.4-1.2,18.8,4.1,25.8c5.3,7,14,11,23.9,11h444.2c9.8,0,18.5-4,23.9-11C507.8,493.9,509.3,484.5,506.6,475.1z M121.7,152
	c0-73.8,60.5-133.9,134.8-133.9S391.3,78.2,391.3,152c0,83.6-123.1,225.6-124.3,227c-5.7,6.6-15.3,6.6-21,0
	C244.7,377.6,121.7,235.6,121.7,152z M487.9,490.1c-1.9,2.5-5.2,3.8-9.3,3.8H34.4c-4.1,0-7.4-1.4-9.3-3.8c-1.9-2.5-2.3-6-1.2-9.9
	l20.3-70.7L67,330.2c1.6-5.4,8.1-10.3,13.8-10.3h96.5c27.4,39.3,52.6,68.3,54.9,71c6.4,7.3,15,11.3,24.3,11.3
	c9.3,0,17.9-4,24.3-11.3c2.3-2.7,27.4-31.6,54.9-71h96.5c5.7,0,12.2,4.9,13.8,10.3l22.8,79.2l20.3,70.7
	C490.2,484,489.8,487.6,487.9,490.1z"
    />
  </SVGWrap>
);

Map.defaultProps = {
  s: {},
  outlineColor: '#000000',
};

Map.propTypes = {
  s: PropTypes.shape({
    width: PropTypes.string,
    height: PropTypes.string,
  }),
  outlineColor: PropTypes.string,
};

export default Map;
